import { Injectable } from '@angular/core';

import { RidangoReduxAction } from '@ridango/core';

@Injectable()
export class PersonalizeActions {
    static RESET_PERSONALIZED_STATE = '[Personalize] Reset personalized state';

    static SAVE_PERSONALIZED_CARD = '[Personalize]: Save personalized card';
    static SAVE_PERSONALIZED_CARD_SUCCESS = '[Personalize]: Save personalized card successful';
    static SAVE_PERSONALIZED_CARD_FAILED = '[Personalize]: Save personalized card failed';

    static SAVE_PERSONALIZED_CARD_NO_ISSUE = '[Personalize]: Save personalized card no issue';
    static SAVE_PERSONALIZED_CARD_NO_ISSUE_SUCCESS = '[Personalize]: Save personalized card no issue successful';
    static SAVE_PERSONALIZED_CARD_NO_ISSUE_FAILED = '[Personalize]: Save personalized card no issue failed';

    static SET_PERSONALIZED_LOADING = '[Personalize] Set personalized loading';

    resetPersonalizedState(): RidangoReduxAction {
        return { type: PersonalizeActions.RESET_PERSONALIZED_STATE };
    }

    savePersonalizedCardNoIssue(payload: any): RidangoReduxAction {
        return {
            type: PersonalizeActions.SAVE_PERSONALIZED_CARD_NO_ISSUE,
            payload: payload
        };
    }
    savePersonalizedCardNoIssueSuccess(payload: any): RidangoReduxAction {
        return {
            type: PersonalizeActions.SAVE_PERSONALIZED_CARD_NO_ISSUE_SUCCESS,
            payload: payload
        };
    }
    savePersonalizedCardNoIssueFailed(error: any): RidangoReduxAction {
        return {
            type: PersonalizeActions.SAVE_PERSONALIZED_CARD_NO_ISSUE_FAILED,
            payload: error
        };
    }

    savePersonalizedCard(payload: any): RidangoReduxAction {
        return {
            type: PersonalizeActions.SAVE_PERSONALIZED_CARD,
            payload: payload
        };
    }

    savePersonalizedCardSuccess(payload: any): RidangoReduxAction {
        return {
            type: PersonalizeActions.SAVE_PERSONALIZED_CARD_SUCCESS,
            payload: payload
        };
    }

    savePersonalizedCardFailed(error: any): RidangoReduxAction {
        return {
            type: PersonalizeActions.SAVE_PERSONALIZED_CARD_FAILED,
            payload: error
        };
    }

    setPersonalizedLoading(loading: boolean): RidangoReduxAction {
        return {
            type: PersonalizeActions.SET_PERSONALIZED_LOADING,
            payload: loading
        };
    }
}
